import classNames from 'classnames'
import { useEffect } from 'react'

import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { SelectInputSM, ToggleInputSM } from '@apps-common/components/elements/form'
import { VertSpacerMd } from '@apps-common/components/layout'
import { useDevSettingsStore } from '@apps-common/stores'

const IS_MON_CENTRE_OPTS = [
  { label: 'Fixed Monitoring Centre', value: 'monitoring_centre' },
  { label: 'Fixed Bureau', value: 'bureau' }
]

export const DevSettings = () => {
  const { enabled, setEnabled, permissions, setPermissions, isMonitoringCentre, setIsMonitoringCentre } = useDevSettingsStore()

  useEffect(() => {
    if (!enabled) {
      setPermissions(null)
      setIsMonitoringCentre(null)
    }
  }, [enabled])

  const getIsMonitoringCentreValue = () => {
    if (isMonitoringCentre === true) {
      return 'monitoring_centre'
    }
    if (isMonitoringCentre === false) {
      return 'bureau'
    }

    return ''
  }

  const setIsMonitoringCentreValue = (value: string) => {
    if (value === 'monitoring_centre') {
      setIsMonitoringCentre(true)
    } else if (value === 'bureau') {
      setIsMonitoringCentre(false)
    } else {
      setIsMonitoringCentre(null)
    }
  }

  return (
    <div className='max-w-[1000px]'>
      <CardContainer bgClasses='bg-surface border border-border md:px-5 md:py-4'>
        <div className='flex items-center justify-between'>
          <SectionTitle classes='text-text-muted/70 text-left pl-[10px]' text='Development' />
        </div>
        <VertSpacerMd />
        <div className='grow text-text rounded-[30px] py-3 pr-3 sm:py-3 sm:pr-4'>
          <ToggleInputSM
            labelLeft='Enabled'
            containerClassName='!mb-0'
            innerContainerClassName='!m-0 !px-0'
            disabled={false}
            registration={{
              checked: enabled,
              onChange: (e: any) => setEnabled(e?.target?.checked)
            }}
          />
          <VertSpacerMd />
          <div className='text-secondary-content '>
            <SelectInputSM
              type='text'
              placeholder='Account default'
              label='Fixed permissions'
              id='FixedPermissions'
              showLabel
              labelClassName={classNames(!enabled && 'opacity-30')}
              containerClassName='w-full'
              className='capitalize'
              disabled={!enabled}
              registration={{ value: permissions || '', onChange: (e: any) => setPermissions(e.target.value) }}
              options={[
                { label: 'Portal User', value: 'portalUser' },
                { label: 'Portal Admin', value: 'portalAdmin' },
                { label: 'Management User', value: 'managementUser' },
                { label: 'Management Admin', value: 'managementAdmin' },
                { label: 'API User', value: 'apiUser' },
                { label: 'API Admin', value: 'apiAdmin' }
              ]}
            />
            <SelectInputSM
              type='text'
              placeholder='Account default'
              label='Fixed Company Type (Is Monitoring Centre)'
              id='FixedIsMonitoringCentre'
              showLabel
              labelClassName={classNames(!enabled && 'opacity-30')}
              containerClassName='w-full'
              className='capitalize'
              disabled={!enabled}
              registration={{ value: getIsMonitoringCentreValue(), onChange: (e: any) => setIsMonitoringCentreValue(e.target.value) }}
              options={IS_MON_CENTRE_OPTS}
            />
          </div>
        </div>
      </CardContainer>
    </div>
  )
}
